import React, { useEffect, useMemo, useState } from "react";
import Layouts from "../../components/Layouts";
import HeaderContentComponent from "../../components/headerContentComponent";
import { Button, message, Space } from "antd";
import { DownloadIcon } from "../../assets/image/svg";
import {
  IColumnType,
  IPagination,
  Table,
} from "../../components/tableComponent/Table";
import { columns } from "./columns";
import DrawerComponent from "../../components/DrawerComponent";
import { useStoreDispatch } from "../../store";
import {
  clearCommentReducers,
  getAllBids,
  getAllBidsExcel,
} from "../../store/bids";
import socket from "../../socket";
import FormViewBet from "../main/formViewBet";
import { filtersBits, getFiltersBits } from "../../store/filters";
import Tooltips from "../main/tooltips";
import { DataAllBidsItem, StorageData } from '../../types';
import { SessionStorageManager } from "../../components/tableComponent/sessionStorageManager";
import { useLocation } from "react-router-dom";
import 'jspdf-autotable';
import moment from 'moment';
import { jsPDF } from 'jspdf';

declare module 'jspdf' {
  interface jsPDF {
    autoTable: any;
  }
}

const Index = () => {
  const dispatch = useStoreDispatch();
  const location = useLocation();
  const [dataAllBids, setDataAllBids] = useState<any>([]);
  const [openDrawerViewContainer, setOpenDrawerViewContainer] = useState<boolean>(false);
  const [current, setCurrent] = useState<number>(1);
  const [page, setPage] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [dataRows, setDataRows] = useState<any[]>([]);
  const [columnFilters, setColumnFilters] = useState({});
  const [checkedAll, setCheckedAll] = useState<any[]>([]);
  const storageManager = new SessionStorageManager(location.pathname);
  const storageLocal: any = storageManager.getItem()
  const [allSelected, setAllSelected] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<Set<number>>(new Set());

  const columnsMemo = useMemo(() => columns, []);

  const fetchData = (current: number, page: number, order: string) => {
    if (storageLocal?.fiters) {
      filtersColumn(storageLocal?.fiters, current, page, "DESC");
    } else {
      dispatch(
        getAllBids({ current: current, page, order, is_archive: true })
      );
    }
  };

  const handleOrder = (order: string) => {
    setLoading(true);
    dispatch(getAllBids({ current: current, page, order, is_archive: true }));
  };

  const filtersColumn = async(
    data: any,
    current: number,
    page: number,
    order: string
  ) => {
    setLoading(true);

    if (storageLocal && storageLocal.pagination !== undefined) {
      storageLocal.pagination.current = current;
      storageLocal.pagination.page = page;
      storageManager.setItem(storageLocal);
    }


    setCurrent(current);
    if (Object.keys(data).length > 0) {
      dispatch(
        getFiltersBits({
          data: data,
          current: current,
          page: page,
          is_archive: true,
          order: order ? order : "DESC",
        })
      );
    } else {
      dispatch(
        getAllBids({
          current: current,
          page: page,
          is_archive: true,
          order: order ? order : "DESC",
        })
      );
    }
  };

  useEffect(() => {
    if (storageLocal) {
      setCurrent(storageLocal.pagination.current);
      setColumnFilters(storageLocal.arrFilters);
      setCurrent(storageLocal.pagination.current);
      setPage(storageLocal.pagination.page);
      fetchData(storageLocal.pagination.current, storageLocal.pagination.page, "DESC");
    } else {
      fetchData(current, page, "DESC");
    }
      socket.on("return-get-all-bids", resAllBids);
      socket.on("error", resError);
      socket.on("return-get-all-bids-excel", resAllBidsExcel);

      return () => {
        socket.off("return-get-all-bids", resAllBids);
        socket.off("error", resError);
        socket.off("return-get-all-bids-excel", resAllBidsExcel);
      };
  }, []);

  const resError = (response: string) => {
    message.error(response);
  };

  const resAllBids = (response: any) => {
    if (response) {
      const data =
        response.order === "DESC" ? response.rows : response.rows.reverse();
      setDataAllBids(data);
      setTotal(response.count);
    }
    setLoading(false);
  };

  const resAllBidsExcel = (response: any) => {
    if (response.rows.length > 0) {
      const rows = response.rows.map(
        ({
          created_at,
          department,
          country1,
          city1,
          country2,
          city2,
          col_ktk,
          quality,
          bet,
          free_days,
          cnp,
          comment,
        }: DataAllBidsItem) => ({
          created_at: moment(created_at).format("DD.MM.YYYY"),
          department,
          country1,
          city1,
          country2,
          city2,
          col_ktk,
          quality,
          bet,
          free_days,
          cnp,
          comment,
        })
      );
      const doc = new jsPDF('landscape');
      const myFont = "/PT_Sans-Web-Regular.ttf";
      doc.addFont(myFont, "PTSans", "normal");
      doc.setFont("PTSans");
      doc.setFontSize(22);

      // Генерация таблицы
      const tableData = rows.map((row: any) => [
        row.created_at,
        row.department,
        row.country1,
        row.city1,
        row.country2,
        row.city2,
        row.col_ktk,
        row.quality,
        row.bet,
        row.free_days,
        row.cnp
      ]);

      // Настройки таблицы
      const tableConfig = {
        head: [["Дата", "Отдел", "Страна 1", "Город 1", "Страна 2", "Город 2", "Кол-во КТК", "Качество", "Ставка", "Свободные дни", "СНП"]],
        body: tableData,
        theme: 'grid',
        headStyles :{lineWidth: 0.1,
          fillColor: [255,255,255],
          textColor: [21,21,21],
          font: "PTSans",
          fontStyle: 'bold',
          halign: "center",
        },
        bodyStyles: {
          fillColor: [255,255,255],
          textColor: [21,21,21],
          font: "PTSans"
        },
        textColor: 20,
        margin: { top: 20, left: 10, right: 10},
        styles: { fontSize: 10,fontStyle: 'italic' },
        tableWidth: 'auto',
        columnStyles: {
          0: { halign: 'center' },
          1: { halign: 'center' },
          2: { halign: 'center' },
          3: { halign: 'center' },
          4: { halign: 'center' },
          5: { halign: 'center' },
          6: { halign: 'center' },
          7: { halign: 'center' },
          8: { halign: 'center' },
          9: { halign: 'center' },
          10: { halign: 'center' },
          11: { halign: 'center' },
        }};

      doc.text('Актуальные ставки MyContainers на ' + moment().format('DD.MM.YYYY'), 10, 10);
      // Добавляем таблицу в PDF
      doc.autoTable(tableConfig);

      const y = 70; // Отступ от верхнего края

      const applyOpacityToImage = (imageSrc: string, opacity: number, callback: (dataUrl: string) => void) => {
        const img = new Image();
        img.src = imageSrc;

        img.onload = function() {
          const canvas = document.createElement('canvas');
          const ctx: any = canvas.getContext('2d');

          // Set canvas size to match the image
          canvas.width = img.width;
          canvas.height = img.height;

          // Set opacity
          ctx.globalAlpha = opacity;

          // Draw image to canvas with the opacity
          ctx.drawImage(img, 0, 0);

          // Get the base64 data of the image with opacity applied
          const dataUrl = canvas.toDataURL('image/png');

          // Use this base64 data URL for the image in jsPDF
          callback(dataUrl);
        };
      };

      applyOpacityToImage('/mk.png', 0.5, (dataUrl) => {
        const totalPages = doc.internal.pages.length;
        for (let i = 1; i <= totalPages; i++) {
          doc.setPage(i);
          doc.addImage(dataUrl, 'PNG', 10, y, 250, 90);
        }

        doc.save('Ставки Мой Контейнер '+moment().format('DD.MM.YYYY')+'.pdf');
      });
    }
  };

  const handleDownload = () => {
    dispatch(getAllBidsExcel({checked: checkedAll,is_archive: true}));
    setSelectedRows(new Set());
    setAllSelected(false);
  };

  const arButton = () => {
    return (
      <>
        <Tooltips title={"Скачать"}>
          <Button icon={<DownloadIcon />} onClick={handleDownload} />
        </Tooltips>
      </>
    );
  };

  const onRowDouble = (payload: any) => {
    setOpenDrawerViewContainer(true);
    setDataRows([payload]);
  };

  const closeFormViewBet = () => {
    setOpenDrawerViewContainer(false);
    dispatch(clearCommentReducers());
  };

  const filtersFetch = (text: string | number, column: IColumnType<any>) => {
    dispatch(filtersBits({ text: text, column: column, is_archive: true }));
  };

  const handleRowSelect = async (value: any) => {
    setCheckedAll(Array.from(value));
  };

  const onChangePagination = async (page: IPagination<any>) => {
    setLoading(true);
    setAllSelected(false);
    setSelectedRows(new Set());
    setCurrent(page.current);
    setPage(page.pageSize);

    try {
      const storageData: StorageData = {
        bull: storageLocal?.bull,
        pagination: { page: page.pageSize, current: page.current, total: page.total }
      };
      storageManager.setItem(storageData);
      if (page.current != null && page.pageSize != null) {
        fetchData(page.current, page.pageSize, "DESC");
      }
    } catch (error) {
      console.error("Error changing pagination:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layouts>
      <HeaderContentComponent setDataAllBids={setDataAllBids} arButton={arButton} title={"Архив"} />
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <Table
          allSelected={allSelected}
          setAllSelected={setAllSelected}
          selectAll={handleRowSelect}
          setSelectedRows={setSelectedRows}
          selectedRows={selectedRows}
          setColumnFilters={setColumnFilters}
          columnFilters={columnFilters}
          onRow={onRowDouble}
          order={handleOrder}
          pagination={{
            pageSize: page,
            total: Number(total),
            current: current,
            showSizeChanger: true,
          }}
          onChangePagination={onChangePagination}
          filters={filtersColumn}
          filtersFetch={filtersFetch}
          columns={columnsMemo}
          loading={loading}
          height={"calc(-169px + 100vh)"}
          dataSource={dataAllBids}
        />
      </Space>
      <DrawerComponent
        open={openDrawerViewContainer}
        onClose={closeFormViewBet}
      >
        <FormViewBet
          typePage={true}
          setOpenDrawerViewContainer={setOpenDrawerViewContainer}
          dataRows={dataRows}
        />
      </DrawerComponent>
    </Layouts>
  );
};

export default Index;
